import React from 'react'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import moment from 'moment'
import { ChartsItemContentProps } from '@mui/x-charts'
import {
  TooltipContainer,
  IconWrapper,
  OverviewBox,
  Label,
  Row,
  Datapoint,
  DateValue,
  GranteeName,
  GranteeGoal,
  DataWrapper,
} from './FunderChart.styled'

export const CustomTooltip = (props: ChartsItemContentProps<any>) => {
  const { itemData, series } = props

  const formattedValue = series.valueFormatter(series.data[itemData.dataIndex])
  const [nonprofitOrgName, valueInfo, dateString, goalName] =
    formattedValue.split(':')

  const formattedDate = moment(dateString).format('MM/DD/YYYY')

  const firstLabel =
    series.id === 'aggregated-series' ? 'Collaborated Goal:' : 'Grantee Name:'

  const secondLabel =
    series.id === 'aggregated-series' ? 'Data Source:' : 'Grantee Goal:'

  return (
    <TooltipContainer color={series.color}>
      {valueInfo !== 'undefined' && (
        <OverviewBox>
          <DataWrapper>
            <IconWrapper color={series.color}>
              <FiberManualRecordIcon sx={{ fontSize: 16 }} />
            </IconWrapper>
            <Datapoint>{valueInfo}</Datapoint>
          </DataWrapper>
          <DateValue>{formattedDate}</DateValue>
        </OverviewBox>
      )}
      <Row>
        <Label>{firstLabel}</Label>
        <GranteeName>{nonprofitOrgName}</GranteeName>
      </Row>
      <Row>
        <Label>{secondLabel} </Label>
        <GranteeGoal>{goalName}</GranteeGoal>
      </Row>
    </TooltipContainer>
  )
}
